// File: src/components/home/ValueAddedServices.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/home/ValueAddedServices.css';

const ValueAddedServices = () => {
  const services = [
    {
      title: 'Car Finance',
      description: 'Get instant loan approval with lowest interest rates starting from 8.5%',
      icon: '💰',
      link: '/finance',
      bgColor: '#E0F2FE'
    },
    {
      title: 'Car Insurance',
      description: 'Comprehensive insurance plans from trusted providers',
      icon: '🛡️',
      link: '/insurance',
      bgColor: '#FEF3C7'
    },
    {
      title: 'Exchange Program',
      description: 'Exchange your old car and get best value instantly',
      icon: '🔄',
      link: '/exchange',
      bgColor: '#D1FAE5'
    },
    {
      title: 'After Sales Service',
      description: 'Regular maintenance and 24/7 roadside assistance',
      icon: '🔧',
      link: '/services',
      bgColor: '#FCE7F3'
    }
  ];

  return (
    <section className="value-services-section">
      <div className="section-container">
        <div className="section-header">
          <h2>Value Added Services</h2>
          <p>Complete car ownership solutions</p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <Link to={service.link} key={index} className="service-card">
              <div className="service-icon" style={{background: service.bgColor}}>
                <span>{service.icon}</span>
              </div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              <span className="learn-more">
                Learn More →
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValueAddedServices;